export default class ConfettiParticle extends Phaser.Sprite {
  constructor(game, colour, canvasWidth, canvasHeight) {
    super(game);

    this.x = Math.random() * this.game.width;
    this.y = Math.random() * this.game.height;
    this.r = Math.random() * 10 + 10;
    this.d = Math.random() * 100 + 10;
    this.colour = colour;
    this.tilt = Math.floor(Math.random() * 10) - 10;
    this.tiltAngleIncremental = Math.random() * 0.07 + 0.05;
    this.tiltAngle = 0;
  }

  drawParticle(canvasContext) {
    canvasContext.beginPath();
    canvasContext.lineWidth = this.r / 2;
    canvasContext.strokeStyle = this.colour;
    canvasContext.moveTo(this.x + this.tilt + this.r / 4, this.y);
    canvasContext.lineTo(this.x + this.tilt, this.y + this.tilt + this.r / 4);
    canvasContext.stroke();
  }
}



// WEBPACK FOOTER //
// ./js/app/ui/confetti/ConfettiParticle.js